import React, { RefObject, useEffect } from "react";
import MapGl, { FlyToInterpolator } from "react-map-gl";

import config from "config";
import { ICoordinate } from "shared/types";
import { MAP_STYLE, useViewport } from "shared/components/Map/utils";
import {
  MapContainer,
  StyledNavigationControl,
  StyledNavigationProps,
  MapContainerProps,
} from "./styles";

export interface BaseMapProps extends StyledNavigationProps, MapContainerProps {
  mapRef?: RefObject<any>;
  zoom?: number | null;
  coordinates?: ICoordinate | null;
  onClick?: (event: any) => void;
  onHover?: (event: any) => void;
  onMouseEnter?: (event: any) => void;
  onMouseLeave?: (event: any) => void;
  interactiveLayerIds?: string[];
}

export const BaseMap: React.FC<BaseMapProps> = ({
  mapRef,
  zoom,
  coordinates,
  children,
  onClick,
  onHover,
  onMouseEnter,
  onMouseLeave,
  navigationPosition,
  borderRadius,
  interactiveLayerIds,
}) => {
  const { longitude, latitude } = coordinates || {};
  const { viewport, setViewport } = useViewport({ coordinates, zoom });

  useEffect(() => {
    setViewport(data => ({
      ...data,
      longitude: longitude || data.longitude,
      latitude: latitude || data.latitude,
      zoom: zoom || data.zoom,
      transitionDuration: 1000,
      transitionInterpolator: new FlyToInterpolator(),
    }));
  }, [longitude, latitude, zoom, setViewport]);

  return (
    <MapContainer borderRadius={borderRadius}>
      <MapGl
        ref={mapRef}
        mapStyle={MAP_STYLE}
        mapboxApiAccessToken={config.mapbox.accessToken}
        height="100%"
        width="100%"
        scrollZoom={false}
        onViewportChange={setViewport}
        onClick={onClick}
        onHover={onHover}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ maxWidth: "100%" }}
        attributionControl={false}
        interactiveLayerIds={interactiveLayerIds}
        {...viewport}
      >
        {children}
        <StyledNavigationControl
          navigationPosition={navigationPosition}
          onViewportChange={setViewport}
          showCompass={false}
        />
      </MapGl>
    </MapContainer>
  );
};
